import { render, staticRenderFns } from "./right-bar.vue?vue&type=template&id=43916ec6&"
import script from "./right-bar.vue?vue&type=script&lang=js&"
export * from "./right-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports